import { render, staticRenderFns } from "./navigation.vue?vue&type=template&id=4d1fa9c8&scoped=true"
import script from "./navigation.vue?vue&type=script&lang=js"
export * from "./navigation.vue?vue&type=script&lang=js"
import style0 from "./navigation.vue?vue&type=style&index=0&id=4d1fa9c8&prod&lang=less"
import style1 from "./navigation.vue?vue&type=style&index=1&id=4d1fa9c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1fa9c8",
  null
  
)

export default component.exports